export default __webpack_public_path__ + "static/media/26_D.04bd8383.svg";